import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { map } from 'rxjs/operators/map';
import { EMPTY } from 'rxjs/internal/observable/empty';
import { catchError, shareReplay, take } from 'rxjs/operators';

import { LoadingService } from '@finder/shared/services/loading-service/loading-service.service';
import { FinderApiConnectorService } from '@finder/shared/services/finder-api-connector/finder-api-connector.service';
import { DESTINATION_NAME_CONSTANTS } from '@finder/shared/constants/app.constants';
import { ConfigService } from '@finder/core/config.service';

@Injectable()
export class ListResolver implements Resolve<Object> {
    private route$ = {};

    constructor(
        private loadingSvc: LoadingService,
        private finderApi: FinderApiConnectorService,
        private configService: ConfigService,
    ) { }

    resolve(route: ActivatedRouteSnapshot) {
        // Here we call the services to get the data ready
        // for the list page

        // Reset of Error state to avoid getting Error message stuck after back button pressed GIT-31197
        this.loadingSvc.setErrorState(null);
        this.loadingSvc.setLoadingState(false);
        const routeType = route.params['type'];
        const destinationName = DESTINATION_NAME_CONSTANTS[this.configService.getValue('siteId')];

        // Let the route replay from the last request.
        if (this.route$[routeType]) {
            return this.route$[routeType];
        }

        this.route$[routeType] = this.finderApi.getListAncestorEntities(routeType)
            .pipe(
                catchError((error) => {
                    this.loadingSvc.setErrorState(error);
                    this.loadingSvc.setLoadingState(true);
                    return EMPTY;
                }),
                // When we navigate back to this page we'll return the last result from the request
                shareReplay({ bufferSize: 1, refCount: true }),
                map((result: any) => {
                    result.locations.unshift({
                        id: -1,
                        title: `All ${destinationName} Locations`
                    });
                    this.loadingSvc.setLoadingState(true);
                    return result;
                }),
                take(1)
            );

        return this.route$[routeType];
    }
}
